import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { isColabApiErrorShape } from '../utils/api';

const MAX_RETRY_ATTEMPTS = 1;
const RETRY_ATTEMPT_TOKEN = new HttpContextToken<number>(() => 0);

export function refreshTnRTokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const errResponse = error.error;
      const isAddSessionPath = req.url.endsWith('/api/user/session/add');

      if (isColabApiErrorShape(errResponse) && error.status === 401 && isAddSessionPath) {
        const colabApiError = errResponse;

        if (colabApiError.error === 'Unauthorised access: ColabBackend - User not found.') {
          router.navigate(['/no-access']);
          return throwError(() => error);
        }

        if (colabApiError.error === 'Unauthorised access: ColabBackend - Cannot create session for an inactive user.') {
          router.navigate(['/no-access']);
          return throwError(() => error);
        }

        const currentAttempts = req.context.get(RETRY_ATTEMPT_TOKEN);
        if (currentAttempts >= MAX_RETRY_ATTEMPTS) {
          router.navigate(['/auth/login']);
          return throwError(() => error);
        }

        return from(authService.refreshTnrToken()).pipe(
          switchMap((newTnrToken) => {
            if (newTnrToken) {
              const retryReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${newTnrToken}`),
                context: req.context.set(RETRY_ATTEMPT_TOKEN, currentAttempts + 1)
              });
              return next(retryReq);
            } else {
              return throwError(() => error);
            }
          })
        );
      }
      return throwError(() => error);
    })
  );
}
